import React from "react"
import Clickable from "@components/clickable"
import classnames from "@utils/classnames"

import * as styles from "./button.module.scss"
import Icon from "../icon"

const Button = ({
  className,
  icon,
  iconClassName,
  children,

  // deprecated
  type,
  tintColor,
  outline,

  ...props
}) => {
  const classNames = classnames(
    "e_btn",
    styles.btn,
    {
      // [styles.blue]: type === "blue",
      // [styles.white]: type === "white",
      // [styles.outline]: outline,
      // [styles.tintColor]: tintColor,
    },
    className
  )
  return (
    <Clickable className={classNames} {...props}>
      <span>
        {children}
        {icon && <Icon icon={icon} className={iconClassName} />}
      </span>
    </Clickable>
  )
}

export default Button
